import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

export class MaratonTimer extends React.Component {


    constructor(props) {
        super(props);
        this.state = { time: new Date() };


        this.setData = this.setData.bind(this);

        this.interval = setInterval(() => {
            this.setData();
        }, 1050);

        this.circleDiv = React.createRef();

    }

    setData() {
        this.setState({ time: new Date() })

    }


    componentDidMount() {
        this.circle = new ProgressBar.Circle(this.circleDiv.current, {
            color: '#fff',
            trailColor: 'rgba(0,0,0,.2)',
            duration: 800,
            easing: 'linear',
            strokeWidth: 8,
            trailWidth: 8,
        });
    }

    componentWillUnmount() {
        clearInterval(this.interval);

        if (this.circle)
            this.circle.destroy();
    }


    render() {
        var now = new Date();
        var toDate = new Date(now.getFullYear(), now.getMonth(), now.getDay(), now.getHours(), 30, 0);

        var diff = new Date(toDate - now);
        var display = casino.utils.dateToTimeString2(diff);

        if (toDate < now)
            if (this.circle)
                this.circle.animate((1800 - (diff.getMinutes() * 60 + diff.getSeconds())) / 1800);

        if (toDate > now) {
            display = '00:00';
            if (this.circle)
                this.circle.animate(1);
        }

  

        return <div className="maraton-timer">
            <div key='i1' className="maratonTimer center-verticaly">
                {display}        </div>
            <div key='i2' id="circle" ref={this.circleDiv} className="progress"></div></div>

    }


};
